import { Compass } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

import { Button, Card, EmptyState, PageHeader } from '@/ui';

export function NotFoundPage() {
  const navigate = useNavigate();

  return (
    <>
      <PageHeader title="Not found" />
      <Card padded={false}>
        <EmptyState
          icon={Compass}
          title="This page doesn't exist"
          description="The address you followed doesn't match anything in the app."
          action={<Button onClick={() => navigate('/')}>Go to dashboard</Button>}
        />
      </Card>
    </>
  );
}
